










































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateM from './create.vue'
import EditM from './edit.vue'
import dayjs from "dayjs";
import Campaign from "@/store/entities/campaign";
import Ajax from '@/lib/ajax'


class PageGiftPackageRequest extends PageRequest {
  campaignId: number = 0;
}

@Component({
  components: {EditM, CreateM}
})
export default class GiftPackagesVM extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  loadOptioning: boolean = false;
  pageRequest: PageGiftPackageRequest = new PageGiftPackageRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  manageGiftShow: boolean = false;
  campaignList: Campaign[] = new Array<Campaign>();

  change(cid) {
    console.log(cid)
    let m = this.campaignList.find(x => x.id == cid);
    console.log(m)
    this.$store.commit('main/setCampaign', m)
  }

  async getCampaign() {
    this.loadOptioning = true;

    let response = await Ajax.get('/api/services/app/Campaign/GetAll', {params: {maxResultCount: 1000,dataState:1}});
    this.campaignList = response.data.result.items as Array<Campaign>;
    this.loadOptioning = false;
  }


  manageGift(giftPackage) {
    this.$store.commit('main/setPackage', giftPackage);
    this.manageGiftShow = true;
  }


  get list() {
    return this.$store.state.giftPackage.list;
  };

  get loading() {
    return this.$store.state.giftPackage.loading;
  }

  create() {
    let m = this.$store.state.main.campaign as Campaign;

    if (!m) {
      this.$Message.error('请选择活动');
      return;
    }
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit('giftPackage/setCurrentPage', page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit('giftPackage/setPageSize', pagesize);
    this.getpage();
  }

  async getpage() {

    this.pageRequest.maxResultCount = this.pageSize;
    this.pageRequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: 'giftPackage/getAll',
      data: this.pageRequest
    })
  }

  get pageSize() {
    return this.$store.state.giftPackage.pageSize;
  }

  get totalCount() {
    return this.$store.state.giftPackage.totalCount;
  }

  get currentPage() {
    return this.$store.state.giftPackage.currentPage;
  }

  columns = [
    {
      title: this.L('ID'),
      key: 'id'
    },
    {
      title: this.L('活动代码'),
      key: 'campaignCode'
    }, {
      title: this.L('礼包名称'),
      key: 'packageName'
    }, {
      title: this.L('礼包代码'),
      key: 'packageCode'
    }, {
      title: this.L('状态'),
      render: (h: any, params: any) => {
        return h('span', params.row.dataState == 1 ? this.L('启用') : this.L('禁用'))
      }
    }

    // , {
    //   title: this.L('礼品管理'),
    //   render: (h: any, params: any) => {
    //     return h('div', [
    //       h('Button', {
    //         props: {
    //           type: 'primary',
    //           size: 'small'
    //         },
    //         style: {
    //           marginRight: '5px'
    //         },
    //         on: {
    //           click: () => {
    //             this.manageGift(params.row);
    //
    //           }
    //         }
    //       }, '查看'),
    //
    //     ])
    //   }
    // }
    , {
      title: this.L('Actions'),
      key: 'Actions',
      width: 150,
      render: (h: any, params: any) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.$store.commit('giftPackage/edit', params.row);
                this.edit();
              }
            }
          }, this.L('Edit')),
          h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: async () => {
                this.$Modal.confirm({
                  title: this.L('Tips'),
                  content: this.L('删除这个礼包？'),
                  okText: this.L('Yes'),
                  cancelText: this.L('No'),
                  onOk: async () => {
                    await this.$store.dispatch({
                      type: 'giftPackage/delete',
                      data: params.row
                    })
                    await this.getpage();
                  }
                })
              }
            }
          }, this.L('Delete'))
        ])
      }
    }]

  async created() {
    await this.getCampaign();
    let m = this.$store.state.main.campaign as Campaign;
    if (m) {
      this.pageRequest.campaignId = m.id;
    }
    await this.getpage();

  }
}
